export default "__VITE_ASSET__tIAtJD4z__"